import { ReactNode } from 'react';
import { createPortal } from 'react-dom';

export type PortalProps = {
  children: ReactNode;
  container: HTMLElement;
};

export const Portal = ({ children, container }: PortalProps) => {
  if (container) {
    return createPortal(children, container);
  }

  console.error('Invalid container given to portal');
  return null;
};
